import * as S from "./AchievementsStamp.style"
import { ReactComponent as SeloWob } from "assets/svgs/icon_selo_wob.svg"

const AchievementsStamp = () => {
    return (
        <S.SectionAchievementsStamp>
            <SeloWob style={{minWidth: "212px", minHeight: "213px"}}/>
            <S.ContentAchievementsStamp>
                <S.TitleAchievementsStamp>
                    Selo WOB (Women on Board)
                </S.TitleAchievementsStamp>
                <S.ParagraphAchievementsStamp>
                    A CSH foi reconhecida em 2024 com o Selo WOB, iniciativa
                    independente apoiada pela ONU Mulheres, que certifica empresas
                    comprometidas com a diversidade e com a igualdade de gênero em
                    Conselhos Executivos e cargos de alta gestão.
                </S.ParagraphAchievementsStamp>
            </S.ContentAchievementsStamp>
        </S.SectionAchievementsStamp>
    )
}

export default AchievementsStamp